<div class="manual-container">

  <!-- ローディング -->
  <div *ngIf="isLoading" class="manual-loading">
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    {{'LOADING' | translate}}
  </div>

  <!-- エラー -->
  <div *ngIf="!isLoading && errorMessage" class="alert alert-danger m-3">
    {{ errorMessage }}
  </div>

  <!-- メインコンテンツ -->
  <div *ngIf="!isLoading && !errorMessage" class="manual-layout">

    <!-- 左パネル: ページ一覧 -->
    <aside class="manual-sidebar">
      <ul class="manual-page-list">
        <li
          *ngFor="let page of pages"
          class="manual-page-item"
          [class.active]="selectedPage?.pageNo === page.pageNo"
          (click)="selectPage(page)"
        >
          {{ page.title }}
        </li>
      </ul>
    </aside>

    <!-- 右パネル: 画像表示 -->
    <main class="manual-content">
      <div *ngIf="pages.length === 0" class="manual-empty">
        {{'MANUAL_NO_DATA' | translate}}
      </div>
      <img
        *ngIf="imageUrl"
        [src]="imageUrl"
        [alt]="selectedPage?.title"
        class="manual-image"
        (error)="onImageError($event)"
      />
    </main>

  </div>
</div>
